module.exports = __webpack_public_path__ + "d3b2639db8349f6e59e614e5b92353ea.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/galo1.svg
// module id = 624
// module chunks = 0